<template>
  <commonbody>
    <div class="corporation-details-header" slot="swiper">
    </div>
    <div :class="['clearfix', getCommonStyle.class]" id="case-box" :style="getCommonStyle.style">
      <div class="case-content-box common-width-box">
        <div class="row case-content-select">
          <div class="col-6 col-md-12 col-lg-6">
            <h2 class="sub-title">精选美酒</h2>
            <div class="sub-desc">有机种植，自然酿造！我们只选择那些真正能反应风土的特色美酒。</div>
          </div>
          <div class="case-content-left col-6 col-md-12 col-lg-6">
            <el-input v-model="query.title" placeholder="请输入关键字" class="search-input" @change="selectCaseDetailsAll(1)" />
            <el-select v-model="query.cases_id" placeholder="请选择酒庄" class="search-input" @change="selectCaseDetailsAll(1)">
              <el-option label="全部酒庄" value=""></el-option>
              <el-option v-for="(item, key) in countryData" :key="key" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="case-content-right">
          <div class="row mx-0" v-if="caseData.length">
            <div style="margin-bottom: 30px;" class="col-3 col-md-6 col-lg-3 card border-0 px-0 py-0"
              v-for="(item, key) in caseData" :key="key">
              <Card :cardData="item" />
            </div>
          </div>
          <div v-else class="none-box">
            暂无数据
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="paginationData.page"
            :page-size="paginationData.pageSize"
            hide-on-single-page
            layout="total, prev, pager, next"
            :total="paginationData.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </commonbody>
</template>
<script>
import commonbody from '@/components/commonbody.vue';
import Card from "@/components/card.vue";
import * as casesApi from '@/api/cases';
import { mapGetters } from 'vuex';
export default {
  name: "Wine",
  components: {
    commonbody,
    Card,
  },
  data() {
    return {
      query: {
        cases_id: ""
      },
      //案例展示
      caseData: [],
      countryData: [],
      paginationData: {
        page: 1,
        pageSize: 16,
        total: 0,
      }
    }
  },
  computed: {
    ...mapGetters(['getCommonStyle']),
  },
  created() {
    this.paramsUrl();
  },
  methods: {
    /**
     * @desc 检测页面是否带了type值初始化type
     */
    paramsUrl() {
      let query = this.$route.query;
      this.selectCases();
      this.selectCaseDetailsAll();
    },
    handleCurrentChange(val) {
      this.paginationData.page = val;
      
      this.selectCaseDetailsAll(val);
    },
    /**
     * @desc 获取案例数据
     */
    selectCaseDetailsAll(valCur) {
      let params = {
        ...this.query,
        page: valCur || 1,
        size: this.paginationData.pageSize,
      };
      casesApi.selectCaseDetailsAll(params).then(res => {
        this.caseData = res.data || [];
        
        this.paginationData.total = res.count;
      })
    },
    /**
     * @desc 获取案例数据
     */
    selectCases() {
      let params = {};
      
      casesApi.selectCases(params).then(res => {
        this.countryData = res.data || [];
      })
    },
  },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
.corporation-details-header {
    height: 64px;
    width: 100%;
    // background: url('../../public/images/bg.png') center;
    background-size: cover;

    img {
        width: 100%;
        max-height: 100%;
    }
}

#case-box {
  height: 100%;
  position: relative;

  .case-content-box {
    height: calc(100% - 200px);
    width: 80%;
    max-width: 1536px;
    margin: 0 auto;
    // padding: 0 20px;
    margin-bottom: 100px;
    position: relative;

    .case-content-select {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      padding-bottom: 20px;

      .sub-desc {
        border: 0;
        padding: 0;
      }
    }

    .case-content-left {
      text-align: right;

      .search-input,
      select {
        width: 200px;
        margin-left: 10px;
      }
    }

    .case-content-right {
      padding-top: 30px;
      padding-bottom: 50px;
    }
  }

}
</style>